var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfrastructure(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 12.8333H12.8333",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72084 12.8333L1.75001 5.81581C1.75001 5.45997 1.91917 5.12167 2.19917 4.9L6.28251 1.72083C6.70251 1.39416 7.29167 1.39416 7.71751 1.72083L11.8008 4.89417C12.0867 5.11583 12.25 5.45414 12.25 5.81581V12.8333",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58334 9.91669H6.41667C5.93251 9.91669 5.54167 10.3075 5.54167 10.7917V12.8334H8.45834V10.7917C8.45834 10.3075 8.06751 9.91669 7.58334 9.91669Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54167 8.02085H4.37501C4.05417 8.02085 3.79167 7.75835 3.79167 7.43752V6.56252C3.79167 6.24169 4.05417 5.97919 4.37501 5.97919H5.54167C5.86251 5.97919 6.12501 6.24169 6.12501 6.56252V7.43752C6.12501 7.75835 5.86251 8.02085 5.54167 8.02085Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 8.02085H8.45833C8.1375 8.02085 7.875 7.75835 7.875 7.43752V6.56252C7.875 6.24169 8.1375 5.97919 8.45833 5.97919H9.625C9.94583 5.97919 10.2083 6.24169 10.2083 6.56252V7.43752C10.2083 7.75835 9.94583 8.02085 9.625 8.02085Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 4.08331L11.0658 2.33331H8.49916",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructure);
export default __webpack_public_path__ + "static/media/Infrastructure.863fd2680b6d63f2c3248c309f0271d3.svg";
export { ForwardRef as ReactComponent };